import { Navigate } from 'react-router-dom';
import DemoAssistant from 'src/pages/poc';
import { PublicLayout } from 'src/layout';

const getPublicRoutes = () => ({
	element: <PublicLayout />,
	children: [
		{
			path: '/assistants/distillery-1',
			element: (
				<DemoAssistant
					assistantAlias="distillery-gcloud"
					initialMessage="Hello"
					countryCode="US"
				/>
			),
		},
		{
			path: '/assistants/distillery-2',
			element: (
				<DemoAssistant
					assistantAlias="distillery-gcloud"
					initialMessage="Hello"
					countryCode="CA"
				/>
			),
		},
		{
			path: '/assistants/distillery-3',
			element: (
				<DemoAssistant
					assistantAlias="distillery-gcloud"
					initialMessage="こんにちは"
					countryCode="JP"
				/>
			),
		},
		{
			path: '/assistants/distillery-google',
			element: (
				<DemoAssistant
					assistantAlias="distillery-gcloud-v2"
					initialMessage="Hello"
					countryCode="US"
				/>
			),
		},
		{
			path: '/assistants/distillery-quest',
			element: (
				<DemoAssistant
					assistantAlias="distillery-quest"
					initialMessage="Hello"
					countryCode="US"
				/>
			),
		},
		{
			path: '*',
			element: <Navigate to="/assistants/distillery-google" replace />,
		},
	],
});

export default getPublicRoutes;
